import { t } from "i18next"

type Props = {
  burdenMaxMonth: number
}

export function DefaultUpperMonthLimit({ burdenMaxMonth }: Props) {
  return (
    <table className={"nbl_info_top_content__table"}>
      <tbody>
        <tr>
          <td className={"large_cell"}>{t("user burden amount")}</td>
          {String(burdenMaxMonth)
            .padStart(6, ".")
            .split("")
            .map((v, indx) => (
              <td key={indx}>{v !== "." ? v : ""}</td>
            ))}
        </tr>
      </tbody>
    </table>
  )
}
